import type { FC } from "react";
import type { ImageComponentSettings } from "../../../Routes/Settings/CustomerDisplay/CustomerDisplayTypes";
import { cache } from "../../../Utilities/Platform/CDN";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import type { CustomerDisplayComponentProps } from "../CustomerDisplay";

interface Props extends CustomerDisplayComponentProps<ImageComponentSettings, null> {}

export const CustomerDisplayImage: FC<Props> = ({ settings }) => {
    let image;

    if(settings.image) {
        image = (
            <img
                alt="customer-display-image"
                src={cache(settings.image, "media")}
            />
        );
    } else {
        image = (
            <div className="image-not-set">
                <FontAwesomeLight icon="file-image" />
            </div>
        );
    }

    // Prepare styling classes from settings
    const classes = [ "customer-display-image w-full h-full" ];

    if(settings.constrainWidth) classes.push("constrain-width");

    if(settings.constrainHeight) classes.push("constrain-height");

    if(settings.fill) classes.push("fill");

    const style = {
        backgroundColor: settings.background,
        color          : settings.color,
    };

    return (
        <div className={classes.join(" ")} style={style}>
            {image}
        </div>
    );
};
